<div *ngIf="!StackedAvatars">
  <div [ngClass]="'avatar-circle-' + Size" [ngStyle]="{ background: backgroundColor }">
    <img class="avatar" *ngIf="imagesLoaded && !imageError[0]" [src]="AvatarImagePath[0]" />
    <img class="icon-avatar" *ngIf="imagesLoaded && imageError[0] && Fallback === 'Icon'" [ngClass]="backgroundColor[0] !== '#f2f2f2' ? 'white-icon' : ''" [src]="IconImagePath[0]" />
    <p class="p-medium" *ngIf="imagesLoaded && imageError[0] && Fallback === 'Initials'" [ngClass]="backgroundColor[0] !== '#f2f2f2' ? 'white-text' : ''">
      {{ Initials[0] }}
    </p>
  </div>
</div>
<div *ngIf="StackedAvatars && imagesLoaded" class="stacked-display-case">
  <div class="stacked-avatars" [ngStyle]="{ 'padding-left': Size === 'small' ? '4px' : Size === 'medium' ? '16px' : Size === 'large' ? '24px' : '40px' }">
    <div [ngClass]="'avatar-circle-' + Size" *ngFor="let avatar of fourArray; let i = index" [ngStyle]="{ background: backgroundColor[i], 'margin-left': Size === 'small' ? '-4px' : Size === 'medium' ? '-16px' : Size === 'large' ? '-24px' : '-40px', 'z-index': fourArray.length - i }">
      <img class="avatar" *ngIf="imagesLoaded && !imageError[i]" [src]="AvatarImagePath[i]" />
      <img class="icon-avatar" *ngIf="imagesLoaded && imageError[i] && (Fallback === 'Icon' || !Initials[i])" [ngClass]="backgroundColor[i] !== '#f2f2f2' ? 'white-icon' : ''" [src]="IconImagePath[i]" />
      <p class="p-medium" *ngIf="imagesLoaded && imageError[i] && Fallback === 'Initials' && Initials[i]" [ngClass]="backgroundColor[i] !== '#f2f2f2' ? 'white-text' : ''">
        {{ Initials[i] }}
      </p>
    </div>
  </div>
  <p class="p-medium" *ngIf="AvatarImagePath.length > 4">+{{ AvatarImagePath.length - 4 }} {{ StackedPluralText }}</p>
</div>
